import { useEffect, useMemo, useState } from "react";
import apiCliente from "../../services/apiCliente";
import { getErpsSistema } from "../../services/erpSistema";

/**
 * ERP(s) do cliente logado no portal — substitui a leitura de `REACT_APP_ERP`
 * nas telas do cliente. Vem do backend (GET /cliente/find/erps), sempre pelo
 * usuário do token: o portal não escolhe ERP. Cliente comum tem um; grupo
 * econômico, os dos membros (podem ser de tipos diferentes). Só o tipo: o
 * cliente não precisa saber qual ERP é.
 *
 * Sem resposta útil (nenhum ERP cadastrado, cliente sem ERP definido ou
 * falha): se o sistema usa um tipo só, ele (a variável ERP, como antes); com
 * vários, nenhum — as telas de um ERP específico não aparecem.
 *
 * @returns {{ erps: Array<{tipo}>, tipos: string[], tipo: string,
 *   temTipo: (tipo: string) => boolean, carregado: boolean }}
 *   `tipo` = o primeiro (o do cliente comum); no grupo, use `tipos`/`temTipo`.
 */
export default function useErpsCliente() {
  const [erps, setErps] = useState(null);

  useEffect(() => {
    let ativo = true;
    apiCliente
      .get("/cliente/find/erps")
      .then((response) => ativo && setErps(response?.data || []))
      .catch((error) => {
        console.error("Erro ao buscar o ERP do cliente:", error);
        if (ativo) setErps([]);
      });
    return () => {
      ativo = false;
    };
  }, []);

  const tipos = useMemo(() => {
    if (erps === null) return [];
    if (erps.length) return [...new Set(erps.map((erp) => erp.tipo))];
    const sistema = getErpsSistema();
    return sistema.length === 1 ? sistema : [];
  }, [erps]);

  return {
    erps: erps || [],
    tipos,
    tipo: tipos[0] || "",
    temTipo: (tipo) => tipos.includes(tipo),
    carregado: erps !== null,
  };
}
